<template>
  <div class="feature-result">
    <FeatureResultSection :slug="featureStore.feature.slug" title="Image shadows have been successfully applied!" />

    <ResultDefault big-result />
  </div>
</template>

<script setup lang="ts">
  import { useFeatureStore } from '$/stores/feature'
  import FeatureResultSection from '&/FeatureResultSection.vue'
  import ResultDefault from '&/ResultDefault.vue'

  const featureStore = useFeatureStore()
</script>
